import { ENTITY_NAME } from '@esentai/core/features/parkingWhitelistGroups/consts';

export const RETRY_FETCH = `${ENTITY_NAME}/RETRY_FETCH`;
